module.exports = __webpack_public_path__ + "img/footer.fa31b7dd.png";